import { memo, useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import { Box, BoxProps, Icon, useStyle } from '@betty/moonlight';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { useInbox } from '../hooks';

const staticPressableStyle: BoxProps = {
  position: 'relative',
  width: 'space-1000',
  height: 'space-1000',
  borderRadius: 'radius-200',
  backgroundColor: 'secondaryBackgroundDefault',
  justifyContent: 'center',
  alignItems: 'center',
};

function InboxHeaderItem(props: BoxProps) {
  const pressableStyle = useStyle({
    ...staticPressableStyle,
    ...props,
  });
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const { hasUnreadMessages } = useInbox();
  const handleClick = useCallback(() => navigation.navigate('InboxModal'), []);

  const UnreadIcon = useMemo(
    () =>
      hasUnreadMessages ? (
        <Box
          width="space-300"
          height="space-300"
          variant="gradient"
          borderRadius="radius-full"
          gradient="attentionBackground"
          position="absolute"
          right="space-100"
          bottom="space-100"
        />
      ) : null,
    [hasUnreadMessages],
  );

  return (
    <Pressable style={pressableStyle} onPress={handleClick}>
      <Icon name="inboxBell" width="space-500" height="space-500" />
      {UnreadIcon}
    </Pressable>
  );
}

export default memo(InboxHeaderItem);
